import {
  DocumentExcelPane,
  type DocumentExcelPaneHighlight,
  type DocumentPaneRenderProps,
} from '@aecom-ai-engineering/react-components';
import { type FC } from 'react';

export interface ExcelRendererOptions {
  highlight?: DocumentExcelPaneHighlight;
  searchable?: boolean;
}

interface ExcelRendererPaneProps extends DocumentPaneRenderProps {
  options?: ExcelRendererOptions;
}

export const ExcelRendererPane: FC<ExcelRendererPaneProps> = ({ options, ...props }) => (
  <DocumentExcelPane
    active={props.active}
    caption={props.caption}
    fileName={props.fileName}
    src={props.src}
    searchable={options?.searchable ?? true}
    highlight={options?.highlight}
  />
);

export function createExcelRenderer(options?: ExcelRendererOptions) {
  return function ExcelRenderer(props: DocumentPaneRenderProps) {
    return <ExcelRendererPane {...props} options={options} />;
  };
}
